import React, { useEffect, useState } from 'react';
import cls from 'classnames';
import { QRCodeSVG } from "qrcode.react";
import back from "../../../assets/images/game/gameback.png";
import { useNavigate } from "react-router-dom"; // 替换 useHistory 为 useNavigate
import './play.scss';

export default function Play() {
    const navigate = useNavigate()

    const [step, setStep] = useState(1) // 第几步
    const [active, setActive] = useState(); // 当前选中的
    const [choose, setChoose] = useState([]) // 所有选中的
    const [end, setEnd] = useState()
    const [showAnimation, setShowAnimation] = useState(false);//点赞动画显示
    const [isPhone, setisPhone] = useState(false);//是否是手机
    const [imgPath, setImgPath] = useState(false);//显示的琴图片
    const data = {
        step1: [
            {
                title: "梧桐木",
                des: [
                    "木质轻柔，不易变形",
                    "具有很好的声学效果",
                    "音沉静而内敛"
                ]
            },
            {
                title: "杉木",
                des: [
                    "木质稳定，香气独特",
                    "含有“杉脑”，抗虫耐腐",
                    "音色醇厚"
                ]
            },
            {
                title: "梓木",
                des: [
                    "纹理细腻，色泽温润",
                    "常被用来制作古琴底板",
                    "音色清亮悦耳"
                ]
            }

        ],
        step2: [{
            title: "仲尼式",
            des: [
                "传统琴式经典",
                "造型简洁，线条有圆有方",
                "蕴含儒者处世之道"
            ]
        }, {
            title: "伏羲式",
            des: [
                "以帝王制琴典故为依托",
                "琴体匀称厚重，琴面弧度较大",
                "腰部内收双连弧形"
            ]
        }, {
            title: "落霞式",
            des: [
                "造型独特的古琴制式",
                "琴身两侧呈对称的波状曲线",
                "形如晚霞万千变化"
            ]
        },

        ],
        step3: [{
            title: "黑色",

        }, {
            title: "栗壳色",
        }
        ],
        step4: [{
            title: "螺钿",

        }, {
            title: "黄金",
        },
        ],
        step5: [{
            title: "青石绿穗",

        }, {
            title: "金黄穗",
        },
        ]

    }
    let showdata = step === 1 ? data.step1 : step === 2 ? data.step2 : step === 3 ? data.step3 : step === 4 ? data.step4 : data.step5
    // 处理步骤变化
    useEffect(() => {
        setActive(choose[step - 1]);
        if (step === 1) {
            setEnd(false);
        }
    }, [step, choose]);

    // 处理结束逻辑
    useEffect(() => {
        if (step === 6) {
            const timer = setTimeout(() => {
                setEnd(true);
                if (choose[4]) {
                    try {
                        const path = require(`../../../assets/images/game/download/${choose.slice(1).join("-")}.png`);
                        setImgPath(path);
                    } catch (error) {
                        console.error("Failed to load image:", error);
                    }
                }
                setChoose([]);
            }, 1000);

            return () => clearTimeout(timer);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [step]); // 只依赖 step，避免 choose 变化时重复执行


    let i = navigator.userAgent.toLowerCase()

    useEffect(() => {
        console.log(window.innerWidth)
        if (/iphone|ipad|android|BlackBerry/.test(i) && window.innerWidth < 1000) {
            setisPhone(true)
        }
    }, [i])
    return (<div className="playpagebox">
        {step === 6 ? <><div className='mix-page'>
            <div className="pic">
                {Array(7).fill("").map((item, index) => {
                    return (
                        <div className={cls("picitem  animate__animated  animate__zoomIn")} style={{ animationDelay: 0.1 * (index + 1) + 's' }} key={index}></div>
                    )
                })}
                <div className="dot-spinner " >
                    <div className="dot"></div>
                    <div className="dot"></div>
                    <div className="dot"></div>
                    <div className="dot"></div>
                    <div className="dot"></div>
                    <div className="dot"></div>
                    <div className="dot"></div>
                    <div className="dot"></div>
                </div>
                <div className="btn  animate__animated  animate__fadeInUp" style={{ animationDelay: '0.8s' }}>您的定制古琴正在加急制作中</div>
            </div>
        </div>
            {end && <div className="down-page">
                <div className="t"></div>
                <div className="qin-img">
                    <img src={imgPath} alt="" srcset="" />
                </div>
                <div className="again" onClick={() => {
                    setStep(1)
                }}>再玩一次</div>
                <div className="btnbox">
                    <div className='zan' onClick={() => {
                        setShowAnimation(true)
                        setTimeout(() => {
                            setShowAnimation(false)
                        }, 500);
                    }}>
                        {showAnimation && <span>+1</span>}
                    </div>
                    <div className='xz' onClick={() => {
                        if (isPhone) {
                            navigate({
                                pathname: "/Game/Play/Pic",
                                search: `?imgPath=${imgPath}`,
                            });
                        }
                    }}>
                        {!isPhone && <div className="ewm-shade">
                            <h4>手机扫描下载图片</h4>
                            <QRCodeSVG
                                value={window.location.href + `/Pic?imgPath=${imgPath}`}
                                size={130}
                                bgColor="#FFFFFF"
                            />
                        </div>}
                    </div>
                </div>
            </div>}
        </> :
            <div className={cls('play-page', { step1: step === 1, step2: step === 2, step3: step === 3, step4: step === 4, step5: step === 5 })}>
                <div className="content">
                    {
                        showdata?.map((item, index) => {
                            return (
                                <div className={cls("item", { "active": active === item.title })} key={index} onClick={() => {

                                    let c = [...choose]
                                    c[step - 1] = item.title
                                    setChoose([...c])
                                }}>
                                    <div className="title">
                                        {item.title}
                                    </div>
                                    <div className="box">
                                        <div className="img">
                                            {active === item.title && <div className="txt animate__animated  animate__fadeIn">
                                                {item?.des && <>
                                                    <h1>特点</h1>
                                                    {item.des.map((item1, index1) => {
                                                        return (
                                                            <p>{item1}</p>
                                                        )
                                                    })}
                                                </>}
                                            </div>}
                                        </div>

                                    </div>
                                </div>
                            )
                        })
                    }

                </div>
                <div className="btnbox">
                    {step !== 1 && <div className="b1" onClick={() => {
                        setStep(step - 1)
                    }}>上一步</div>}
                    <div className={cls("b2", { "disable": !active })}
                        onClick={() => {
                            setStep(step + 1)
                        }}>下一步</div>
                </div>

            </div>}
        <img
            src={back}
            alt=""
            className="back"
            onClick={() => {
                navigate("/")
            }}
        />
    </div>
    )
}
